import { Modal, Badge } from "react-bootstrap";
import { ServerRequestsSubscriptionGroupContractRuleDto } from "./shared/api/axios-client";
import { useMemo } from "react";

type Props = {
  show: boolean;
  onHide: () => void;
  contract: ServerRequestsSubscriptionGroupContractRuleDto[];
    groupName: string; 
};

enum RateType {
  Fee = 0,
  Discount = 1,
}

export default function ContractDetailsModal({
  show,
  onHide,
  contract,
  groupName,
}: Props) {
  const sortedContract = useMemo(() => {
    return [...contract].sort((a, b) => {
      const aMin = a.min ?? Number.MAX_SAFE_INTEGER;
      const bMin = b.min ?? Number.MAX_SAFE_INTEGER;
      return aMin - bMin;
    });
  }, [contract]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Contract Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-3">
          <div className="text-muted small">
            The following pricing rules apply to <strong>{groupName}</strong>
          </div>
        </div>

        <div className="fw-semibold mb-2">Tier Rules</div>

        <div className="d-flex flex-column gap-2">
          {sortedContract.map((r, i) => {
            const isNoCost = !r.price || r.price === 0;
            const isFee = r.type === RateType.Fee;
            const displayPrice = Math.abs((r.price ?? 0) / 100);

            return (
              <div
                key={i}
                className="d-flex align-items-center justify-content-between px-3 py-2 rounded border"
              >
                <div>
                  <div className="fw-medium">
                    {r.min ?? 0} – {r.max ?? "∞"} parkers
                  </div>

                  <div className="text-muted small">
                    {isNoCost
                      ? "No additional cost"
                      : isFee
                      ? "Monthly fee applied"
                      : "Monthly discount applied"}
                  </div>
                </div>

                <Badge
                  bg={isNoCost ? "secondary" : isFee ? "danger" : "success"}
                  pill
                >
                  {isNoCost
                    ? "No Cost"
                    : `${isFee ? "+" : "−"} $${displayPrice.toFixed(2)}`}
                </Badge>
              </div>
            );
          })}
        </div>
      </Modal.Body>
    </Modal>
  );
}